import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/ResourcesHub/Banner';
import Bits from '../Components/Pages/ResourcesHub/Bits';
import Features from '../Components/Pages/ResourcesHub/Features';
import Product from '../Components/Pages/ResourcesHub/Product';
import What from '../Components/Pages/ResourcesHub/What';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function ResourcesHub(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Features />
        <What />
        <Product />
        <Bits />
        <Start />
        <Footer />
        </>
    )
};
export default ResourcesHub;